// src/components/Navigation/Navigation.js
import React, { useState } from 'react';
import { motion } from 'framer-motion';
import './Navigation.css';
import { useNavigate, useLocation } from 'react-router-dom';

const Navigation = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToSection = (id) => {
    // If we're not on the homepage, navigate to homepage first
    if (location.pathname !== '/') {
      navigate('/');
      // Wait for navigation to complete, then scroll
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    } else {
      // If we're already on homepage, just scroll
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const goToHomepage = () => {
    navigate('/');
    // Scroll to top after navigation
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 100);
  };

  const openWaitlist = () => {
    document.getElementById('waitlistModal').style.display = 'block';
    document.body.style.overflow = 'hidden';
  };

  return (
    <motion.nav 
      className="navigation"
      initial={{ y: -100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6 }}
    >
      <div className="nav-container">
        {/* Replaced logo image with text */}
        <button 
          onClick={goToHomepage} 
          className="logo"
          style={{ 
            background: 'none', 
            border: 'none', 
            cursor: 'pointer', 
            display: 'flex', 
            alignItems: 'center',
            fontFamily: "'Migra', sans-serif",
            fontWeight: 'bold',
            fontSize: '24px',
            color: 'inherit',
            textDecoration: 'none'
          }}
        >
          Gus<i>Home</i>
        </button>
        
        <ul className={`nav-links ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
          <li><button onClick={() => scrollToSection('features')}>Features</button></li>
          <li><button onClick={() => scrollToSection('how-it-works')}>How It Works</button></li>
          <li><button onClick={() => scrollToSection('pricing')}>Pricing</button></li>
          <li>
            <button className="waitlist-btn" onClick={openWaitlist}>
              Join Waitlist
            </button>
          </li>
        </ul>
        
        <button 
          className="mobile-menu-btn"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          ☰
        </button>
      </div>
    </motion.nav>
  );
};

export default Navigation;